// core
import { Injectable } from '@angular/core';


// This is what the old mock data used to look like, they have been moved to data/dev/[home/car]/quote
// // mock data
// import { StepQuotePurpose } from '../../data/step-quote-purpose';
// import { StepPreferredCover } from '../../data/step-preferred-cover';
// import { StepMainDriver } from '../../data/step-main-driver';
// import { StepHuddleId } from '../../data/step-huddle-id';

// // home mock data
// import { StepHomeAddress } from '../../data/step-home-address';
// import { StepHomeOwnerType } from '../../data/step-home-owner-type';
// import { StepHomeStrataType } from '../../data/step-home-strata-type';
// import { StepHomePreferredCover } from '../../data/step-home-preferred-cover';
// import { StepHomeConstructionDetails } from '../../data/step-home-construction-details';
// import { StepHomeSecurityDetails } from '../../data/step-home-security-details';
// import { StepHomeInsuranceHistory } from '../../data/step-home-insurance-history';
// import { StepHomePolicyholders } from '../../data/step-home-policyholders';


@Injectable({
  providedIn: 'root'
})
export class SdkDataService {
  constructor() { }

  /**
   * @function addZeros
   * @memberof SdkDataService
   * @summary Formats a number as a string with leading zeros defined by size
   * @example
   * @param {number} value Value to be converted into a string
   * @param {number} size Minimum string length of the formatted number
   * @returns {void} VOID
   * @description This is an old mate used to tokenize number values, display pricing etc.
   */
  addZeros(value: number, size: number) {
    let zeroedValue = value.toString();
    if (zeroedValue.length < size) {
      for (let i = 0, j = zeroedValue.length; i < j; i++) {
        zeroedValue = '0' + zeroedValue;
      }
    }
    return zeroedValue;
  }
  /**
   * @function buildDataToken
   * @memberof SdkDataService
   * @summary Builds a data reference token from parameters
   * @example
   * @param {string} country Region of data fixture(au/nz)
   * @param {string} product Product type of data fixture(home/car/travel)
   * @param {string} lookup Lookup type(quote/endorsement/cancellation), defaults as lookup
   * @param {string} step Number of the data fixture file(max 99)
   * @returns {string} Token reference to a fixture data file
   * @description This function provides the mechnism to "dynamically" import a data file.
   * Data files are organised internally as [country]/(address|prices|quote)/(step|lookup)-[step]
   */
  buildDataToken(country: string, product: string, lookup: string, step: number) {
    var token = country + '-' + product + '-' + lookup + '-';
    if (lookup === "quote") {
      token += 'step-' + this.addZeros(step, 2);
    }
    else {
      token += 'lookup-' + this.addZeros(step, 2);
    }

    return token;
  }
  /**
   * @function getFile
   * @memberof SdkDataService
   * @summary Takes a token reference to data fixture file and returns an import promise that returns the contents of the file
   * @example
   * @param {string} token
   * @returns {Promise<any>} The default data property of the imported module as a promise
   * @description This function decouples data fixtures from production package bundling.
   * We cannot dynamically build import file paths using a promise the import method returns.
   * To achieve dynamic control over fixture imports we can dynamically build a reference token and import the corresponding file.
   * Therefore, this function contains a manifest of all importable data fixtures for the sdk with their tokens.
   * example url: http://localhost:54228/quote/aus/car/03
   */
  getFile(token: string): Promise<any> {
    var promise; // must be any for dynamic promise loading
    var type = 'none';
    var valid = false;
    promise = import('../data/aus/car/step-01.json');

    // build the promise w/ validation
    switch(token) {
      // Car flow : /quote/aus/car/
      case 'aus-car-quote-step-00': promise = import('../data/aus/car/step-knockout.json'); valid = true; break;
      case 'aus-car-quote-step-01': promise = import('../data/aus/car/step-01.json'); valid = true; break;
      case 'aus-car-quote-step-02': promise = import('../data/aus/car/step-02.json'); valid = true; break;
      case 'aus-car-quote-step-03': promise = import('../data/aus/car/step-03.json'); valid = true; break;
      case 'aus-car-quote-step-04': promise = import('../data/aus/car/step-04.json'); valid = true; break;
      case 'aus-car-quote-step-05': promise = import('../data/aus/car/step-05.json'); valid = true; break;
      case 'aus-car-quote-step-06': promise = import('../data/aus/car/step-06.json'); valid = true; break;
      case 'aus-car-quote-step-07': promise = import('../data/aus/car/step-07.json'); valid = true; break;
      case 'aus-car-quote-step-08': promise = import('../data/aus/car/step-08.json'); valid = true; break;
      case 'aus-car-quote-step-09': promise = import('../data/aus/car/step-09.json'); valid = true; break;
      case 'aus-car-quote-step-10': promise = import('../data/aus/car/step-10.json'); valid = true; break;
      case 'aus-car-quote-step-11': promise = import('../data/aus/car/step-11.json'); valid = true; break;
      case 'aus-car-quote-step-12': promise = import('../data/aus/car/step-12.json'); valid = true; break;
      case 'aus-car-quote-step-13': promise = import('../data/aus/car/step-13.json'); valid = true; break;
      case 'aus-car-quote-step-14': promise = import('../data/aus/car/step-14.json'); valid = true; break;
      case 'aus-car-quote-step-15': promise = import('../data/aus/car/step-15.json'); valid = true; break;
      case 'aus-car-quote-step-16': promise = import('../data/aus/car/step-16.json'); valid = true; break;

      // Travel flow : /quote/aus/travel/
      case 'aus-travel-quote-step-01': promise = import('../data/aus/travel/step-01.json'); valid = true; break;
      case 'aus-travel-quote-step-02': promise = import('../data/aus/travel/step-02.json'); valid = true; break;
      case 'aus-travel-quote-step-03': promise = import('../data/aus/travel/step-03.json'); valid = true; break;
      case 'aus-travel-quote-step-04': promise = import('../data/aus/travel/step-04.json'); valid = true; break;
      case 'aus-travel-quote-step-05': promise = import('../data/aus/travel/step-05.json'); valid = true; break;
      case 'aus-travel-quote-step-06': promise = import('../data/aus/travel/step-06.json'); valid = true; break;
      case 'aus-travel-quote-step-07': promise = import('../data/aus/travel/step-07.json'); valid = true; break;
      case 'aus-travel-quote-step-08': promise = import('../data/aus/travel/step-08.json'); valid = true; break;
      case 'aus-travel-quote-step-09': promise = import('../data/aus/travel/step-09.json'); valid = true; break;
      case 'aus-travel-quote-step-10': promise = import('../data/aus/travel/step-10.json'); valid = true; break;

      // Landlord flow : /quote/nz/landlord/
      case 'nz-landlord-quote-step-00': promise = import('../data/nz/landlord/step-knockout.json'); valid = true; break;
      case 'nz-landlord-quote-step-01': promise = import('../data/nz/landlord/step-01.json'); valid = true; break;
      case 'nz-landlord-quote-step-02': promise = import('../data/nz/landlord/step-02.json'); valid = true; break;
      case 'nz-landlord-quote-step-03': promise = import('../data/nz/landlord/step-03.json'); valid = true; break;
      case 'nz-landlord-quote-step-04': promise = import('../data/nz/landlord/step-04.json'); valid = true; break;
      case 'nz-landlord-quote-step-05': promise = import('../data/nz/landlord/step-05.json'); valid = true; break;
      case 'nz-landlord-quote-step-06': promise = import('../data/nz/landlord/step-06.json'); valid = true; break;
      case 'nz-landlord-quote-step-07': promise = import('../data/nz/landlord/step-07.json'); valid = true; break;
      case 'nz-landlord-quote-step-08': promise = import('../data/nz/landlord/step-08.json'); valid = true; break;
      case 'nz-landlord-quote-step-09': promise = import('../data/nz/landlord/step-09.json'); valid = true; break;
      case 'nz-landlord-quote-step-10': promise = import('../data/nz/landlord/step-10.json'); valid = true; break;
      case 'nz-landlord-quote-step-11': promise = import('../data/nz/landlord/step-11.json'); valid = true; break;
      case 'nz-landlord-quote-step-12': promise = import('../data/nz/landlord/step-12.json'); valid = true; break;
      case 'nz-landlord-quote-step-13': promise = import('../data/nz/landlord/step-13.json'); valid = true; break;
      case 'nz-landlord-quote-step-14': promise = import('../data/nz/landlord/step-14.json'); valid = true; break;
      case 'nz-landlord-quote-step-15': promise = import('../data/nz/landlord/step-15.json'); valid = true; break;
      case 'nz-landlord-quote-step-16': promise = import('../data/nz/landlord/step-16.json'); valid = true; break;
      case 'nz-landlord-quote-step-17': promise = import('../data/nz/landlord/step-17.json'); valid = true; break;
      case 'nz-landlord-quote-step-18': promise = import('../data/nz/landlord/step-18.json'); valid = true; break;
      case 'nz-landlord-quote-step-19': promise = import('../data/nz/landlord/step-19.json'); valid = true; break;
      case 'nz-landlord-quote-step-20': promise = import('../data/nz/landlord/step-20.json'); valid = true; break;

      // Mobile flow : /quote/uk/mobile/
      case 'uk-mobile-quote-step-00': promise = import('../data/uk/mobile/step-knockout.json'); valid = true; break;
      case 'uk-mobile-quote-step-01': promise = import('../data/uk/mobile/step-01.json'); valid = true; break;
      case 'uk-mobile-quote-step-02': promise = import('../data/uk/mobile/step-02.json'); valid = true; break;
      case 'uk-mobile-quote-step-03': promise = import('../data/uk/mobile/step-03.json'); valid = true; break;
      case 'uk-mobile-quote-step-04': promise = import('../data/uk/mobile/step-04.json'); valid = true; break;
      case 'uk-mobile-quote-step-05': promise = import('../data/uk/mobile/step-05.json'); valid = true; break;
      case 'uk-mobile-quote-step-06': promise = import('../data/uk/mobile/step-06.json'); valid = true; break;
      case 'uk-mobile-quote-step-07': promise = import('../data/uk/mobile/step-07.json'); valid = true; break;
      case 'uk-mobile-quote-step-08': promise = import('../data/uk/mobile/step-08.json'); valid = true; break;
      case 'uk-mobile-quote-step-09': promise = import('../data/uk/mobile/step-09.json'); valid = true; break;

      // Travel flow : /quote/uk/travel/
      case 'uk-travel-quote-step-01': promise = import('../data/uk/travel/step-01.json'); valid = true; break;
      case 'uk-travel-quote-step-02': promise = import('../data/uk/travel/step-02.json'); valid = true; break;
      case 'uk-travel-quote-step-03': promise = import('../data/uk/travel/step-03.json'); valid = true; break;
      case 'uk-travel-quote-step-04': promise = import('../data/uk/travel/step-04.json'); valid = true; break;
      case 'uk-travel-quote-step-05': promise = import('../data/uk/travel/step-05.json'); valid = true; break;
      case 'uk-travel-quote-step-06': promise = import('../data/uk/travel/step-06.json'); valid = true; break;
      case 'uk-travel-quote-step-07': promise = import('../data/uk/travel/step-07.json'); valid = true; break;
      case 'uk-travel-quote-step-08': promise = import('../data/uk/travel/step-08.json'); valid = true; break;
      case 'uk-travel-quote-step-09': promise = import('../data/uk/travel/step-09.json'); valid = true; break;
      case 'uk-travel-quote-step-10': promise = import('../data/uk/travel/step-10.json'); valid = true; break;
      case 'uk-travel-quote-step-11': promise = import('../data/uk/travel/step-11.json'); valid = true; break;
      case 'uk-travel-quote-step-12': promise = import('../data/uk/travel/step-12.json'); valid = true; break;
    }

    // chain behaviour to the promise and get file data
    if (valid) {
      return promise.then(json => {
        return this.getImportData(json);
      }).catch(error => {
      });
    }
    // return empty resolved promise if token is invalid
    else {
      return new Promise((resolve) => {
        resolve(true);
      });
    }
  }
  /**
   * @function getImportData
   * @memberof SdkDataService
   * @summary Gets the data from the imported module object
   * @example
   * @param {object} dataModule Object created by Angular when using an import statement which is hooked onto a promise
   * @returns {object} The default value of the imported module if the data was mounted correctly, otherwise an empty object
   * @description Angular import() statement returns a promise with a module object as its handle, the data is mounted on the "default" property.
   * This method returns that object data in a typesafe way.
   */
  getImportData(dataModule: object) {
    let data = {};
    var keys = Object.keys(dataModule);
    for (let i = 0, j = keys.length; i < j; i++) {
      if (keys[i] === 'default') {
        let key = keys[i] as keyof typeof data;
        data = dataModule[key];
      }
    }

    return data;
  }
}
